const highlightMatch = (option: string, inputValue: string) => {
  if (!inputValue) return <>{option}</>;
  const lowerOption = option.toLowerCase();
  const lowerInput = inputValue.toLowerCase();
  const matchIndex = lowerOption.indexOf(lowerInput);

  const beforeMatch = option.slice(0, matchIndex);
  const match = option.slice(matchIndex, matchIndex + inputValue.length);
  const afterMatch = option.slice(matchIndex + inputValue.length);

  return (
    <span className="text-black/30">
      {beforeMatch}
      <span className="text-black">{match}</span>
      {afterMatch}
    </span>
  );
};

export default highlightMatch;
